// Url where the static json defining documents exists.
const DOC_API_URL =
    process.env.REACT_APP_DOCUMENT_DATA_URL || "docs.json";

// Individual document model.
export interface Documentation {
    name: string;
    ext: string;
    title: string;
    description: string;
    keywords: string[];
    build_date: string;
    build: string;
}

// Response from the DOCUMENTATION_URL json document.
export interface DocumentationResponse {
    // Value is either a documentation model or an empty object.
    [key: string]: Documentation | Record<string, never>;
}

// Single instance data access object.
const DocumentService = {
    // Returns a promise of an array of Documentation models.
    async get(): Promise<Documentation[]> {
        // Retrieve response from the documentation endpoint.
        const response = await fetch(DOC_API_URL);

        // Decode as json and cast to DocumentationResponse.
        const docs = (await response.json()) as DocumentationResponse;

        // Remove empty documents.
        const completeDocs = Object.values(docs).filter(
            (doc) => "ext" in doc
        ) as Documentation[];

        return completeDocs;
    },
} as const;

export { DocumentService };
